export const getMainDomain = () => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    if (parts.length > 1) {
        return parts.slice(1).join('.');
    }
    return hostname;
};